import { useState } from 'react';
import { getTranslation } from '../../constants/translations';

import './About.scss';

export const About = () => {
  const t = getTranslation();
  const [openedSection, setOpenedSection] = useState<string | null>(null);
  const [openedSubsection, setOpenedSubsection] = useState<string | null>(null);

  const toggleSection = (name: string) => {
    if (openedSection === name) {
      setOpenedSection(null);
    } else {
      setOpenedSection(name);
    }

    setOpenedSubsection(null);
  };

  const toggleSubection = (name: string) => {
    if (openedSubsection === name) {
      setOpenedSubsection(null);
    } else {
      setOpenedSubsection(name);
    }
  };

  return (
    <section className="main__about about">
      <div className="_container">
        <h2 className="about__title title">{t.about.title}</h2>

        <ul className="about__container">
          {t.about.sectionsList.map((section) => (
            <li key={section.title} className="about__section">
              <div
                className="about__section-name"
                onClick={() => toggleSection(section.title)}
              >
                {section.title}{' '}
                <span
                  className="about__arrow"
                  style={{
                    transform: `${openedSection === section.title ? 'rotate(-90deg)' : 'rotate(90deg)'}`,
                  }}
                ></span>
              </div>

              <ul
                className="about__subsections-list"
                style={{
                  display: `${openedSection === section.title ? 'block' : 'none'}`,
                }}
              >
                {section.subsections.map((subsection) => (
                  <li key={subsection.title} className="about__subsection">
                    <div
                      className="about__section-name about__section-name--subsection"
                      onClick={() => toggleSubection(subsection.title)}
                    >
                      {subsection.title}
                      <span
                        className="about__arrow about__arrow--subsection"
                        style={{
                          transform: `${openedSubsection === subsection.title ? 'rotate(-90deg)' : 'rotate(90deg)'}`,
                        }}
                      ></span>
                    </div>

                    <p
                      className="about__text"
                      style={{
                        display: `${openedSubsection === subsection.title ? 'block' : 'none'}`,
                      }}
                    >
                      {subsection.text}
                    </p>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        {/* <button className="about__button button">
          {t.common.knowledgeBtn}
        </button> */}
      </div>
    </section>
  );
};
